import { render } from "./OrderPopup.vue?vue&type=template&id=d1716364&scoped=true"
import script from "./OrderPopup.vue?vue&type=script&lang=js"
export * from "./OrderPopup.vue?vue&type=script&lang=js"

import "./OrderPopup.vue?vue&type=style&index=0&id=d1716364&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1716364"]])

export default __exports__